var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInhaler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59464 2.35392L9 4.75776L3.34411 6L3.00406 3.56332C2.97376 3.34624 3.11607 3.14218 3.33211 3.0929L8.07574 2.01096C8.3164 1.95607 8.55404 2.11313 8.59464 2.35392Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43754 10.6711L3.63339 12.091L7.33745 11.2679C7.7418 11.178 8.14243 11.433 8.23229 11.8373C8.32215 12.2417 8.0672 12.6423 7.66285 12.7322L3.83903 13.5819L4.94061 21.5684C4.97473 21.8158 5.18617 22 5.43592 22H14.5001C14.7763 22 15.0001 21.7762 15.0001 21.5V15.5C15.0001 15.2239 14.7763 15 14.5001 15H11.4237C11.1793 15 10.9707 14.8233 10.9305 14.5822L9.58758 6.52462C9.54019 6.24029 9.26283 6.05481 8.98195 6.11963L3.44548 7.39728C3.19333 7.45547 3.02724 7.69644 3.0626 7.95279L3.2319 9.18025L7.33745 8.2679C7.7418 8.17805 8.14243 8.433 8.23229 8.83735C8.32215 9.2417 8.0672 9.64233 7.66285 9.73218L3.43754 10.6711Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16H17.5C18.0523 16 18.5 16.4477 18.5 17V20C18.5 20.5523 18.0523 21 17.5 21H16.5V16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 16.5C21.1642 16.5 21.5 16.1642 21.5 15.75C21.5 15.3358 21.1642 15 20.75 15C20.3358 15 20 15.3358 20 15.75C20 16.1642 20.3358 16.5 20.75 16.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20.75C21.5 21.1642 21.1642 21.5 20.75 21.5C20.3358 21.5 20 21.1642 20 20.75C20 20.3358 20.3358 20 20.75 20C21.1642 20 21.5 20.3358 21.5 20.75Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19C21.1642 19 21.5 18.6642 21.5 18.25C21.5 17.8358 21.1642 17.5 20.75 17.5C20.3358 17.5 20 17.8358 20 18.25C20 18.6642 20.3358 19 20.75 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhaler);
export default __webpack_public_path__ + "static/media/inhaler.23c4466cf9a892e6e9086cba32a9e335.svg";
export { ForwardRef as ReactComponent };